import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '../../Select';
import { MemoryProgressBar } from '../MemoryProgressBar';
import { MEMORY_KEEPER_TOUR_TARGETS } from '../../../../lib/shared/memory-keeper-tour-steps';
import styles from './MemoryChatSelector.css';

function MemoryChatSelector({ chapters, activeChapter, onSelect }) {
    const options = chapters.map((chapter) => chapter.label);
    const { answerCount, answersUntilMemory } = activeChapter;

    const handleChange = (name, label) => {
        const selected = chapters.find((chapter) => chapter.label === label);

        if (selected) {
            onSelect(selected.id);
        }
    };

    return (
        <div className={styles.root} data-tour={MEMORY_KEEPER_TOUR_TARGETS.CHAPTER}>
            <Select
                className={styles.selector}
                name='chapter'
                options={options}
                value={activeChapter.label}
                label='Pick a chapter of your life to talk through'
                onChange={handleChange}
            />
            {answersUntilMemory !== 0 && (
                <>
                    <span className={styles.remainingLabel}>
                        {`${answersUntilMemory} ${answersUntilMemory === 1 ? 'answer' : 'answers'} left to create your memory`}
                    </span>
                    <MemoryProgressBar value={answerCount} max={answerCount + answersUntilMemory} />
                </>
            )}
        </div>
    );
}

MemoryChatSelector.propTypes = {
    chapters: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        answerCount: PropTypes.number.isRequired
    })).isRequired,
    activeChapter: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        answerCount: PropTypes.number.isRequired,
        answersUntilMemory: PropTypes.number.isRequired
    }).isRequired,
    onSelect: PropTypes.func.isRequired
};

export {
    MemoryChatSelector
};
